import { FlexLayout } from '../../components/layout/Flex';
import { Cover } from '../../components/Text';
import { TechIcons } from '../../assets/visual/png/icons';

const TechStack = () => {
	return (
		<FlexLayout direction="column">
			<div
				style={{
					padding: '10vh',
				}}
			>
				<Cover>My Weapons</Cover>
			</div>
			<div
				style={{
					justifyContent: 'center',
					textAlign: 'center',
				}}
			>
				{TechIcons.map(a => {
					return (
						<img
							key={a.id}
							src={a.src}
							alt={a.alt}
							width="10%"
							height="auto"
							style={{ paddingLeft: '10px', minWidth: '80px' }}
						/>
					);
				})}
			</div>
		</FlexLayout>
	);
};

export default TechStack;
